import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import { isArray } from "util";
import EditPelnSub from "./editPelnSub.js";

const MySwal = withReactContent(Swal2);

const AddCounterClaim = (props) => {
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(
    props.clientsData.counterclaim ? props.clientsData.counterclaim : "NIE"
  );

  const getData = async () => {
    return;
  };

  useEffect(() => {
    getData();
  }, []);

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validate = () => {
    if (value.length === 0) {
      return false;
    }

    return true;
  };

  const generateDocument = async () => {
    if (!validate()) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
      return;
    }

    var bodyX = {
      id: props.clientsData.id,
      value: value,
    };

    fetch("https://apidevkppp.ftpeople.pl/updateCounterclaim", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(bodyX),
    })
      .then((response) => response.text())
      .then((responseJson) => {
        MySwal.fire({
          icon: "success",
          title: "Edytowano",
          text: "informacje o sprawie",
        }).then(async (result) => {
          props.close();
        });
      });
  };

  const handleValueChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <div
      style={{ width: "50vw", top: "25vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div id="addPaymentIC" className="inputContainer">
            <>
              <div id="addPaymentIC" className="inputContainer">
                <div className="inputBox">
                  <div style={{ minWidth: "49%" }} className="inputCol_2">
                    <label>
                      Pozew wzajemny?
                      <span className="requiredStar">*</span>
                    </label>
                    <select
                      type="text"
                      id="court"
                      name="court"
                      value={value}
                      onChange={handleValueChange}
                    >
                      <option key={0} value="TAK">
                        TAK
                      </option>
                      <option key={1} value="NIE">
                        NIE
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={generateDocument}>
                ZAPISZ
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddCounterClaim;
